import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCPixConclusionComponent = class UiCPixConclusionComponent {
    constructor() { }
    ngOnInit() {
        this.textDeclaration = this.validation ? 'PIX.PIX_CONCLUSION.CONCLUSION_VALIDATE_DESCRIPITION' : 'PIX.PIX_CONCLUSION.CONCLUSION_DESCRIPITION';
    }
};
__decorate([
    Input()
], UiCPixConclusionComponent.prototype, "urlImg", void 0);
__decorate([
    Input()
], UiCPixConclusionComponent.prototype, "validation", void 0);
UiCPixConclusionComponent = __decorate([
    Component({
        selector: 'ui-c-pix-conclusion',
        template: "<ion-row class=\"ion-justify-content-center ion-align-items-center\">\n  <ion-col size=\"7\">\n    <svg-icon [stretch]=\"false\" class=\"ion-margin-bottom\" [src]=\"urlImg\"></svg-icon>\n  </ion-col>\n</ion-row>\n\n<ion-text class=\"ion-text-center\">\n  <p class=\"font-family-bold ion-margin margin-bottom-and-top-30\">\n    {{ textDeclaration | wlpTranslate }}\n  </p>\n</ion-text>\n\n<ion-text class=\"ion-text-center\">\n  <p class=\"ion-margin margin-bottom-and-top-30\">{{ 'PIX.PIX_CONCLUSION.CONCLUSION_SUBTITLE' | wlpTranslate }}</p>\n</ion-text>\n",
        styles: [""]
    })
], UiCPixConclusionComponent);

let UiCPixConclusionModule = class UiCPixConclusionModule {
};
UiCPixConclusionModule = __decorate([
    NgModule({
        declarations: [UiCPixConclusionComponent],
        imports: [CommonModule, ReactiveFormsModule, IonicModule, UiBsTranslateModule, AngularSvgIconModule],
        exports: [UiCPixConclusionComponent],
    })
], UiCPixConclusionModule);

/*
 * Public API Surface of ui-c-pix-conclusion
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCPixConclusionComponent, UiCPixConclusionModule };
//# sourceMappingURL=wlp-ui-c-pix-conclusion.js.map
